import querystring from 'querystring';

/**
 * Parses hash parameters.
 *
 * At the moment, userId and questionnaireId
 * are values provided by the onboarding front end.
 */
export const parseHashParams = () => {
  const vals = querystring.parse(window.location.hash.replace('#', ''));
  const { userId, questionnaireId } = vals;

  return { userId, questionnaireId };
};



// WEBPACK FOOTER //
// ./src/modules/parse-hash-params.js